export default __webpack_public_path__ + "static/media/group.ff06eec9.png";